import React from 'react';
import { Link } from 'react-router-dom';
import Chip from '@mui/material/Chip';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import SvgIcon from '@mui/material/SvgIcon';
import clsx from "clsx";
import { ReactComponent as ReportIcon } from "assets/images/criticalIncident/exclamation_diamond.svg";
import { TruncatedText } from 'components/Shared';

import "./StatusChip.scss";

export type StatusChipStatus = 'default' | 'warning' | 'success' | 'error' | 'info';

const STATUS_ICONS: Record<StatusChipStatus, React.ReactElement> = {
    default: null as unknown as React.ReactElement,
    warning: <WarningRoundedIcon color="warning" />,
    success: <CheckCircleOutlinedIcon color="success" />,
    error: <SvgIcon component={ReportIcon} color="error" style={{ padding: '4px' }} inheritViewBox />,
    info: <InfoRoundedIcon color="info" />,
};

type StatusChipProps = {
    status: StatusChipStatus;
    href?: string;
} & (
    | { label: string; children?: never }
    | { children: React.ReactNode; label?: never }
) & (
    | { icon: React.ReactElement; showIcon?: never }
    | { showIcon?: boolean; icon?: never }
);

export const StatusChip: React.FC<StatusChipProps> = ({ status, label, children, icon, showIcon, href }) => {
    const resolvedIcon = icon ?? (showIcon ? STATUS_ICONS[status] : undefined);
    const resolvedLabel = label ?? children;
    const chipLabel = href
        ? <Link to={href}>{resolvedLabel}</Link>
        : resolvedLabel;

    return (
        <Chip
            label={<TruncatedText>{chipLabel}</TruncatedText>}
            icon={resolvedIcon}
            className={clsx("status-chip", status)}
        />
    );
};
